import React from "react";
import { STATUS_LABELS } from "@/lib/api";

const COLOR = {
  REGISTERED: { bg: "bg-slate-100", text: "text-slate-700", dot: "bg-slate-400" },
  DOCUMENTS_UPLOADED: { bg: "bg-sky-50", text: "text-sky-700", dot: "bg-sky-500" },
  UNDER_REVIEW: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500" },
  EXPERT_OPINION: { bg: "bg-violet-50", text: "text-violet-700", dot: "bg-violet-500" },
  UPDATE_SENT: { bg: "bg-cyan-50", text: "text-cyan-700", dot: "bg-cyan-500" },
  PROCESSED: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500" },
};

export default function StatusBadge({ status }) {
  const c = COLOR[status] || COLOR.REGISTERED;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold ${c.bg} ${c.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}
